"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectButtonWapper = exports.onConnect = exports.reConnect = exports.onDisconnect = exports.connectSlice = exports.DEFAULT_TOKENS_FOR_WEB3_MODE = void 0;
const react_1 = __importStar(require("react"));
const Connect_1 = require("unifyre-extension-web3-retrofit/dist/contract/Connect");
const ferrum_plumbing_1 = require("ferrum-plumbing");
const unifyre_extension_web3_retrofit_1 = require("unifyre-extension-web3-retrofit");
const toolkit_1 = require("@reduxjs/toolkit");
const AppState_1 = require("../store/AppState");
const react_redux_1 = require("react-redux");
const types_1 = require("types");
const ApiClient_1 = require("../clients/ApiClient");
exports.DEFAULT_TOKENS_FOR_WEB3_MODE = [
    types_1.FRM['RINKEBY'][0],
    types_1.FRM['ETHEREUM'][0],
    types_1.FRM['POLYGON'][0],
    types_1.FRMX['ETHEREUM'][0],
    types_1.FRM['BSC_TESTNET'][0],
    types_1.FRM['MUMBAI_TESTNET'][0],
    types_1.ETH['ETHEREUM'][0],
    types_1.ETH['RINKEBY'][0],
    types_1.ETH['BSC_TESTNET'][0],
    types_1.ETH['BSC'][0],
    types_1.ETH['POLYGON'][0],
    types_1.ETH['MUMBAI_TESTNET'][0],
];
exports.connectSlice = toolkit_1.createSlice({
    name: 'connect',
    initialState: {
        user: AppState_1.dummyAppUserProfile,
    },
    reducers: {
        connectionSucceeded: (state, action) => {
            const { userProfile } = action.payload;
            state.user = userProfile;
            state.connectionError = undefined;
        },
        userProfileUpdated: (state, action) => {
            const { userProfile } = action.payload;
            state.user = userProfile;
            state.connectionError = undefined;
        },
        reconnected: (state, action) => {
            const { userProfile } = action.payload;
            state.user = userProfile;
            state.connectionError = undefined;
        },
        connectionFailed: (state, action) => {
            state.connectionError = action.payload.message || action.payload.toString();
        },
        disconnect: state => {
            state.connectionError = undefined;
            state.user = AppState_1.dummyAppUserProfile;
        },
        clearError: state => {
            state.connectionError = undefined;
        }
    }
});
const Actions = exports.connectSlice.actions;
exports.onDisconnect = toolkit_1.createAsyncThunk('connect/onDisconnect', async (payload, ctx) => {
    const connect = types_1.inject(Connect_1.Connect);
    console.log('Disconnecting...');
    await connect.getProvider().disconnect();
    ctx.dispatch(Actions.disconnect());
});
exports.reConnect = toolkit_1.createAsyncThunk('connect/reConnect', async (payload, ctx) => {
    const [client, connect, api] = types_1.inject3(unifyre_extension_web3_retrofit_1.UnifyreExtensionWeb3Client, Connect_1.Connect, ApiClient_1.ApiClient);
    await connect.reset();
    const userProfile = await client.getUserProfile();
    const res = await api.signInToServer(userProfile);
    if (res) {
        ctx.dispatch(Actions.reconnected({ userProfile }));
    }
    else {
        ctx.dispatch(exports.onDisconnect({}));
    }
});
exports.onConnect = toolkit_1.createAsyncThunk('connect/onConnect', async (payload, ctx) => {
    var _a;
    const [client, connect, currencyList, api, provider] = types_1.inject5(unifyre_extension_web3_retrofit_1.UnifyreExtensionWeb3Client, Connect_1.Connect, unifyre_extension_web3_retrofit_1.CurrencyList, ApiClient_1.ApiClient, 'Web3ModalProvider');
    try {
        if (payload.isAutoConnect && !provider.isCached()) {
            return; // Dont try to connect if we are not cached.
        }
        connect.setProvider(provider);
        await client.signInWithToken('');
        const net = await connect.getProvider().netId();
        const network = await connect.network();
        const newNetworkCurrencies = (currencyList.get() || []).filter(c => c.startsWith(network || 'NA'));
        if (net && newNetworkCurrencies.length == 0) {
            currencyList.set(exports.DEFAULT_TOKENS_FOR_WEB3_MODE);
        }
        // Subscribe to session disconnection
        // console.log('Provider is...', connect.getProvider())
        connect.getProvider().addEventListener('disconnect', (reason) => {
            console.log('DISCONNECTED FROM WALLET CONNECT', reason);
            ctx.dispatch(Actions.disconnect());
        });
        connect.getProvider().addEventListener('change', () => {
            console.log('RECONNECTING');
            ctx.dispatch(exports.reConnect({}));
        });
        const userProfile = await client.getUserProfile();
        const res = await api.signInToServer(userProfile);
        if (res) {
            ctx.dispatch(Actions.connectionSucceeded({ userProfile }));
        }
        else {
            (_a = connect.getProvider()) === null || _a === void 0 ? void 0 : _a.disconnect();
        }
    }
    catch (e) {
        console.error('wsConnect', e);
        if (e) {
            try {
                console.log('Disconnecting failed connection !!', e);
                if (provider) {
                    await provider.disconnect();
                }
            }
            catch (de) {
                console.error('Error disconnecting provider ', de);
            }
            ctx.dispatch(Actions.connectionFailed({ message: `Connection failed ${e.message}` }));
        }
    }
});
const AUTO_CON = { tried: false };
function ConnectButtonWapper(props) {
    const dispatch = react_redux_1.useDispatch();
    const appInitialized = react_redux_1.useSelector(state => state.data.init.initialized);
    const connected = react_redux_1.useSelector(state => { var _a, _b; return !!((_b = (_a = state.connection.account) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.userId); });
    const address = react_redux_1.useSelector(state => { var _a; return AppState_1.addressForUser((_a = state.connection.account) === null || _a === void 0 ? void 0 : _a.user); });
    const balances = react_redux_1.useSelector(state => { var _a; return AppState_1.addressesForUser((_a = state.connection.account) === null || _a === void 0 ? void 0 : _a.user); });
    const error = react_redux_1.useSelector(state => state.connection.account.connectionError);
    const connector = async () => {
        dispatch(exports.onConnect({ isAutoConnect: true }));
    };
    react_1.useEffect(() => {
        if (AUTO_CON.tried)
            return;
        if (appInitialized && !connected) {
            AUTO_CON.tried = true;
            connector();
        }
    }, [connector, appInitialized, connected]);
    ferrum_plumbing_1.ValidationUtils.isTrue(!!props.View, '"View" must be set');
    if (!appInitialized) {
        return (react_1.default.createElement("div", null, "..."));
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(props.View, { connected: connected, address: (address === null || address === void 0 ? void 0 : address.address) || '', balances: balances, network: (address === null || address === void 0 ? void 0 : address.network) || '', error: error, onClick: () => {
                if (connected) {
                    dispatch(exports.onDisconnect({ isAutoConnect: false }));
                }
                else {
                    dispatch(exports.onConnect({ isAutoConnect: false }));
                }
            } })));
}
exports.ConnectButtonWapper = ConnectButtonWapper;
//# sourceMappingURL=ConnectButtonWrapper.js.map